import { TIME_CONSTANTS } from '../../../constants/time';

/**
 * Business logic utilities for heartbeat banner behavior.
 * Contains rules and decisions related to banner display and interaction.
 */

/**
 * Calculate if banner can be dismissed based on time remaining.
 * Banner cannot be dismissed when 15 minutes or less remaining.
 *
 * @param timeRemainingMs - Time remaining in milliseconds
 * @returns Whether the banner can be dismissed
 */
export const canDismissBanner = (timeRemainingMs: number): boolean => {
	return timeRemainingMs > TIME_CONSTANTS.FIFTEEN_MINUTES_MS;
};
